import { http } from "@/core/api/";

export default {
  completeAtService(peiAtServiceId) {
    return http.post(`api/atservice/complete/${peiAtServiceId}`, {});
  },
  async notCompleteAtService(peiAtServiceId) {
    return http.post(`api/atservice/notcomplete/${peiAtServiceId}`, {});
  },
  async createAtService(peiId) {
    const data = { peiId: peiId };
    const result = await http.post(`api/atservice/saveGeneral`, data);

    if (result && result.status === 200) {
      return result.data;
    }

    return 0;
  },
  async uploadEvaluationDocument(peiAtServiceId, params) {
    return http.post(
      `api/atservice/${peiAtServiceId}/uploadEvaluationDocument`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  },
  async getPeiAtServiceSimpleData(id) {
    return http.get(`api/atservice/${id}/simple`);
  },
  async schoolDiscussionUploadDocument(peiAtServiceId, params) {
    return http.post(
      `api/atservice/${peiAtServiceId}/schoolDiscussionUploadDocument`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  },
  async deleteDocument(peiAtServiceId, documentTypeId) {
    return http.delete(
      `api/atservice/${peiAtServiceId}/documentType/${documentTypeId}`
    );
  },
  async getDocumentAttachments(peiAtServiceId) {
    return await http.get(
      `api/atservice/documentAttachments/${peiAtServiceId}`
    );
  }
};
